import { EstadosProcesoEnumChoice, gridSizeMdLg12, gridSizeMdLg4, TABLE_CONSTANTS, useCheckPermissions, useTableFilter, useTableServerSideFiltering } from "@/shared";
import { useFetchOrdenesCompras } from "@/shared/actions/erp";
import { GeneralTable, SingleButton } from "@/shared/components/ui";
import useTableOrdeneCompra from "../../shared/hook/useTableOrdenCompra";
import { OrdenesCompra } from "@/shared/interfaces/erp/compras/ordenes-compra.interface";
import { Grid, IconButton, Tooltip, Typography } from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useState } from "react";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import SampleTablePagination from "@/shared/components/ui/SampleTablePagination";
import DescriptionIcon from '@mui/icons-material/Description';
import { toast } from "react-toastify";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { useFileDowloadDoc } from '@/shared/hooks/useDownloadFileDoc';
import PhotoSizeSelectActualIcon from '@mui/icons-material/PhotoSizeSelectActual';
import { PermissionsEnum } from "@/auth/interfaces";
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';

export default function OdenesCompraAbiertoPage() {
  //
  useCheckPermissions(PermissionsEnum.api_view_ordencompra);
  ///**********store
  const handldeCopiarLista = useCargarSeriesProductos(s => s.handleCopiarLista)
  const paginationTable = useCargarSeriesProductos(s => s.pagination)
  const setPaginationTable = useCargarSeriesProductos(s => s.setPagination)
  const paginatedData = useCargarSeriesProductos(s => s.paginatedData)
  const productos = useCargarSeriesProductos(s => s.productos)
  //***********state
  const [respaldoOpenModal, setRespaldoOpenModal] = useState(false)
  const [urlRevisionSolicitud, setUrlRevisionSolicitud] = useState('')
  const [urlOrdenCompra, setUrlordenCompra] = useState('')
  const [urlRevisorOrden, setUrlRevisorOrden] = useState('')

  const {
    pagination,
    setPagination,
  } = useTableFilter()

  const { pageIndex, pageSize } = pagination
  const [isOpenModal, setIsModalOpen] = useState(false)


  const { columnFilters, setColumnFilters, filterObject } = useTableServerSideFiltering()
  //normalizamos 
  const normalizeFilters = (filters: Record<string, any>) => {
    const result: Record<string, any> = {}
    Object.entries(filters).forEach(([key, value]) => {
      const cleanKey = key.includes('.') ? key.split('.').pop()! : key
      const mappedKey = cleanKey === 'razon_social' ? 'proveedor_razon_social' : cleanKey
      result[mappedKey] = value
    })
    return result
  }

  const {
    data: dataOrdenParcial,
    isLoading,
    isRefetching
  } = useFetchOrdenesCompras({
    page: pageIndex + 1,
    page_size: pageSize,
    estado_orden: EstadosProcesoEnumChoice.ABIERTO,
    ...normalizeFilters(filterObject)
    //...filterObject,
    //filterByState:false
  })
  const {
    infoDetallesAbierto,
    infoProducto

  } = useTableOrdeneCompra()
  const {
    downloadFile
  } = useFileDowloadDoc()
  //**************cargamos los datos */
  const handleAction = (data: OrdenesCompra) => {
    handldeCopiarLista(data.detalles!)
    setIsModalOpen(true)
  }

  ///****funcion para descargar el orden compra */
  const onDownload = (e: string) => {
    if(!e) return toast.error('El archivo PDF no se ha generado.')
    downloadFile({
      url: e,
      nameFile: 'Orden Pedido'
    })
  }
  ///**********dowload*/
  const handleDowloadRevisionSolicitud = async () => {
    /*   console.log('descarga', urlRevisionSolicitud)
      return; */
    if (!urlRevisionSolicitud)
      return toast.info('El usuario que realizó la revisión no subió ningun respaldo.')
    downloadFile({
      url: urlRevisionSolicitud,
      nameFile: 'Respaldo_aprobación_revisorSolicitud',
      //extensionFile: 'pdf'
    })
  }

  const handleDowloadOrdenCompra = () => {
    ///console.log(urlOrdenCompra)
    if (!urlOrdenCompra)
      return toast.info('El usuario que genero la orden de compra no subió ningun respaldo.')
    downloadFile({
      url: urlOrdenCompra,
      nameFile: 'Respaldo_aprobación_OrdenCompra',
      //extensionFile: 'pdf'
    })
  }
  const handleDowloadRevisionOrden = () => {
    console.log('ordenreviso', urlRevisorOrden)
    if (!urlRevisorOrden)
      return toast.info('El usuario que reviso la orden de compra no subió ningun respaldo.')
    downloadFile({
      url: urlRevisorOrden,
      nameFile: 'Respaldo_aprobación_RevisionOrden',
      //extensionFile: 'pdf'
    })
  }
  //***********************FUNCION QUE VERIFICA EL TIPO DE URL/
  const esPdf = (url: string) => url.toLowerCase().endsWith('.pdf')
  //
  return (
    <>
      < GeneralTable<OrdenesCompra>
        columns={infoDetallesAbierto}
        data={dataOrdenParcial?.data.data || []}
        isLoading={isLoading}
        isRefetching={isRefetching}
        pagination={pagination}
        onPaging={setPagination}
        rowCount={dataOrdenParcial?.data.count}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        enableManualFiltering={true}
        enableSorting={false}
        canEdit={false}
        //actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_MEDIUM}
        actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH}
        showCustomActionBtnSpace={true}
        customActionBtnSpace={(value) => {
          return (
            <Grid container >
              <Grid item>
                <Tooltip title="Descargar" placement="top">
                  <IconButton
                    color="info"
                    onClick={() => {
                      onDownload(value.url_pdf!)
                    }}
                  >
                    <ArrowCircleDownIcon />
                  </IconButton>

                </Tooltip>
              </Grid>
              <Grid item>
                <Tooltip title="Ver">
                  <IconButton
                    onClick={() => {
                      handleAction(value)
                    }}
                  >
                    <VisibilityIcon />
                  </IconButton>
                </Tooltip>
              </Grid>

              <Grid item>
                <Tooltip title="Visualización de Respaldos">
                  <IconButton
                    onClick={() => {
                      const archivoRevision = value?.solicitud_ingreso_data?.urls_imagenes?.archivoRevision
                      setUrlRevisionSolicitud(archivoRevision!);
                      setUrlordenCompra(value.urls_imagenes?.urlOrden!)
                      setUrlRevisorOrden(value.urls_imagenes?.urlOrdenRevision!)
                      setRespaldoOpenModal(true)
                    }}
                  >
                    <DescriptionIcon />
                  </IconButton>

                </Tooltip>

              </Grid>

            </Grid>
          )
        }}

      />
      <ScrollableDialogProps
        title="DETALLES DE PRODUCTO"
        open={isOpenModal}
        onCloseIcon={() => setIsModalOpen(false)}
        minWidth="60%"
        contentNode={
          <>
            <SampleTablePagination
              columns={infoProducto}
              data={paginatedData}
              rowCount={productos.length}
              pagination={paginationTable}
              setPagination={setPaginationTable}
            />

          </>
        }
      />

      <ScrollableDialogProps
        open={respaldoOpenModal}
        title='Respaldos de Aprobación'
        onCloseIcon={() => setRespaldoOpenModal(false)}
        minWidth='47%'
        //minHeight='40%'
        contentNode={
          <>
            <Grid container spacing={3}>
              <Grid item xs={12} justifyContent={'center'}>
                {urlRevisionSolicitud || urlOrdenCompra || urlRevisorOrden ? (
                  <Typography variant='h6' fontWeight="bold" color="text.secondary">
                    {'Click para descargar los documentos'}
                  </Typography>

                ) : (
                  <Typography mt={4} color="text.secondary" textAlign={"center"}>
                    {'No existe ningun respaldos'}

                  </Typography>

                )}

              </Grid>
              <Grid item {...gridSizeMdLg12}>
                <Grid container spacing={2} >
                  {urlRevisionSolicitud && (
                    <Grid item {...gridSizeMdLg4}>
                      <SingleButton
                        label='Revisor Solicitud'
                        variant="outlined"
                        onClick={handleDowloadRevisionSolicitud}
                        startIcon={esPdf(urlRevisionSolicitud) ? (
                          <PictureAsPdfIcon />
                        ) : (
                          <PhotoSizeSelectActualIcon />
                        )
                        }
                      />

                    </Grid>
                  )}
                  {urlOrdenCompra && (
                    <Grid item {...gridSizeMdLg4}>
                      <SingleButton
                        label='Creador de la Orden'
                        variant="outlined"
                        color={'error'}
                        onClick={handleDowloadOrdenCompra}
                        startIcon={esPdf(urlOrdenCompra) ? (
                          <PictureAsPdfIcon />
                        ) : (
                          <PhotoSizeSelectActualIcon />
                        )}
                      />
                    </Grid>
                  )}
                  {urlRevisorOrden && (
                    <Grid item {...gridSizeMdLg4}>
                      <SingleButton
                        label=' Revisor de la orden'
                        variant="outlined"
                        color={'success'}
                        onClick={handleDowloadRevisionOrden}
                        startIcon={esPdf(urlRevisorOrden) ? (
                          <PictureAsPdfIcon />
                        ) : (
                          <PhotoSizeSelectActualIcon />
                        )}
                      />

                    </Grid>
                  )}


                </Grid>


              </Grid>
            </Grid>
          </>
        }
      />
    </>
  )
}